import { Component, inject, signal, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TRANSLATION_SCOPE, translationProvider } from './i18n/translation.provider';
import { TranslocoDirective } from '@ngneat/transloco';
import { AuthConfig, AuthConfigService, AuthFacade } from '@rx-applications/shared/auth/data-access';
import { PhoneNumberInputComponent, RxAlertModule, RxButtonModule } from '@roomex/rx-components';
import { FormControl, FormsModule } from '@angular/forms';

@Component({
  selector: 'rx-applications-feature-setup-mfa',
  standalone: true,
  imports: [CommonModule, TranslocoDirective, RxAlertModule, PhoneNumberInputComponent, RxButtonModule, FormsModule],
  templateUrl: './feature-setup-mfa.component.html',
  styleUrl: './feature-setup-mfa.component.scss',
  providers: [translationProvider],
})
export class FeatureSetupMfaComponent {
  protected readonly TRANSLATION_SCOPE = TRANSLATION_SCOPE;
  protected authConfig: AuthConfig = inject(AuthConfigService).config;
  protected authFacade: AuthFacade = inject(AuthFacade);

  phoneNumberControl: FormControl<string> = new FormControl('');

  phoneNumber: WritableSignal<string> = signal<string>('');

  submit(): void {
    this.phoneNumberControl.markAsTouched();
    if (this.phoneNumberControl.valid) {
      this.authFacade.setupMfa(this.phoneNumber());
    }
  }
}
